export default __webpack_public_path__ + "static/media/continue-saved-article-pink.8be4f537.svg";